/**
 * Tutorial guidato dei Permessi per profilo.
 *
 * Il passo sui moduli illumina la matita e non la finestra che apre. Quella finestra
 * e' costruita con un `v-if` sopra la `v-dialog`, e quando Vuetify la chiude - per
 * esempio con Esc - il nodo resta a schermo mentre lo stato la da' per chiusa:
 * aprendola dal tutorial resterebbe li', e la X non basterebbe a mandarla via.
 */
const SCOPE = '[data-tour-scope="setting-permissions-profile"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createPermissionsByProfileTourSteps() {
	return [
		{
			body: "I permessi per ruolo dicono cosa puo' fare un mestiere; qui si scende di un livello e si decide cosa vede un singolo profilo - cioe' una specifica attivita' fra quelle ospitate sul gestionale.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I permessi per profilo',
		},
		{
			body: "L'elenco dei profili, con la ricerca in cima che filtra mentre scrivi. E' un elenco lungo: la ricerca e' il modo piu' rapido per arrivare a quello che serve.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Trovare un profilo',
		},
		{
			body: "La matita a fine riga apre la finestra dei moduli di quel profilo: una casella per ogni sezione del gestionale, spuntata dove il profilo ha accesso. Si esce con la X in alto a sinistra e si conferma con Save - le spunte non valgono finche' non si salva.",
			key: 'edit-open',
			placement: 'left',
			target: at('edit-open'),
			title: 'Aprire i moduli di un profilo',
		},
	];
}
